import { type FieldValidator, type PrimitiveField, type ValidationError } from '@adv-frontend/form-kit';

/*
 * Создает валидатор, проверяющий, что значение является положительным целым числом или нулем
 *
 * @param code код ошибки
 * @returns валидатор
 */
export function integerPositiveOrZeroValidator<
    Code extends string,
    FieldValue extends string,
    FieldContextInput,
    FieldContext,
    FieldActions,
    FieldSelectors,
>(
    code: Code,
    {
        empty: hasEmpty = false,
    }: {
        empty?: boolean;
    } = {}
): FieldValidator<
    PrimitiveField<FieldValue, ValidationError<Code>, FieldContextInput, FieldContext, FieldActions, FieldSelectors>
> {
    return (value, fieldApi) => {
        if (hasEmpty && value === '') {
            return;
        }

        const numValue = parseFloat(value);

        if (!Number.isInteger(numValue) || numValue < 0) {
            fieldApi.addValidationError({
                code,
            });
        }
    };
}
